import { RESET_ALL as RESET_ON_LOGOUT } from './common-reducer';

import { createReducer } from 'utils/redux';
import { API, destroy } from 'utils/api';
import { logError } from 'utils/log';

const { INSTAGRAM_POSTS, TIKTOK_POSTS } = API.END_POINTS;

const DELETING = 'instagram-posts/DELETING';
const DELETED = 'instagram-posts/DELETED';

import type { Action, Dispatch } from 'types';

const initialState = {
  posts: [],
  isLoading: false
};

const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,

  payload: {
    status
  }
});

const postsDeleted = (posts: Array<string>): Action => ({
  type: DELETED,

  payload: {
    posts
  }
});

export const deletePosts = (posts: Array<string>, type: 'instagram' | 'tiktok'): any => async (dispatch: Dispatch) => { // eslint-disable-line consistent-return
  dispatch(setLoadingStatus(DELETING, true));

  try {
    const url = (type === 'instagram')
      ? INSTAGRAM_POSTS.deletePosts()
      : TIKTOK_POSTS.deletePosts();
    await destroy(url, { data: posts }, { suppressGlobalNotification: true });

    dispatch(setLoadingStatus(DELETING, false));

    return dispatch(postsDeleted(posts));
  } catch (e) {
    dispatch(setLoadingStatus(DELETING, false));
    logError(e);
  }
};

export default createReducer<any, any>('instagramPostsDelete', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [DELETING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [DELETED]: (state, { posts }) => ({
    ...state,
    posts
  })
});
